import * as $ from 'jquery';

$(function () {
    /**
     * Mobile menu open close
     */
    $(document).on("click", ".mobile-button-menu", (e) => {
       
        if($('.mobile-menu').hasClass('closed')){
            $('.mobile-menu').removeClass('none');
            $('.mobile-menu').removeClass('closed');
            $('.mobile-menu').addClass('opened');
            $('body').addClass('stop-scrolling')
            e.preventDefault();
        } else {
            $('.mobile-menu').removeClass('opened');
            $('.mobile-menu').addClass('closed');
            $('body').removeClass('stop-scrolling')
            e.preventDefault();
        }
    });


    $(document).on("click", ".mobile-link",(e) => {
       
        if($('.mobile-menu').hasClass('opened')){
            $('.mobile-menu').removeClass('opened');
            $('.mobile-menu').addClass('closed');
            $('body').removeClass('stop-scrolling')
            e.preventDefault();
        } else {
           
        }
    });

    $( window ).resize(function(e) {
        if($( window ).width() >= 992) {
            if($('.mobile-menu').hasClass('opened')){
                $('.mobile-menu').removeClass('none');
                $('.mobile-menu').removeClass('opened');
                $('.mobile-menu').addClass('closed');
                $('body').removeClass('stop-scrolling')
                e.preventDefault();
            } 
        }
       console.log($( window ).width());
      });
});


// WEBPACK FOOTER //
// ./src/pages/home/scripts/mobile-menu/mobile-menu.js